module.exports = __webpack_public_path__ + "static/img/14.847e450.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/14.jpg
// module id = +VjM
// module chunks = 0